module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "college-search"
    }
  }, [_c('div', {
    attrs: {
      "id": "college-list"
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        _vm.showColleges = !_vm.showColleges
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.selectedCollegeInd == null ? 'Select College' : 'Change College') + "\n      "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      show: _vm.showColleges
    },
    attrs: {
      "id": "list-wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.colleges), function(college, i) {
    return _c('a', {
      staticClass: "ds-main ds-color-hover",
      class: {
        active: _vm.selectedCollegeInd == i
      },
      on: {
        "click": function($event) {
          return _vm.selectCollege(i)
        }
      }
    }, [_vm._v("\n            " + _vm._s(college.key) + "\n          ")])
  }), 0)])]), _vm._v(" "), (_vm.selectedCollegeInd != null) ? _c('div', {
    ref: "collegePlaceholder",
    attrs: {
      "id": "college-majors"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.selectedCollege.key))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.selectedCollege.values.length) + " Program" + _vm._s(_vm.selectedCollege.values.length > 1 ? 's' : ''))]), _vm._v(" "), _c('major-list', {
    attrs: {
      "majors": _vm.filteredColleges,
      "collegeSelectorShown": true
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52418889","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CollegeSearch.vue
// module id = 992
// module chunks = 1